import { ReactNode } from 'react';
import { ProspectOutcomeDisplayName } from '../../../../../sequence/enums';
import { OutcomeSentiment } from '../../../../enums/custom-outcome';

// import { IProps as IPropsContainer } from './custom-outcome-dropdown-container';

export type IPropsComponent = {
  className?: string;
  initialSelectedOption?: Option | null;
  showFooter: boolean;
  options: Option[];
  showTotal: boolean;
  onChange?: (option) => void;
  optionRenderer: (option) => ReactNode;
  selectedOptionRenderer?: (option) => JSX.Element;
  selectedOptionClassName?: string;
  changeOutcomeRequestPayload?: any;
  disableAutomaticOpening?: boolean;
  disabled?: boolean;
  callOutcome?: boolean;
  /** When set, used for the closed (selected) trigger icon instead of the built-in getOutcomeIcon / getCallOutcomeIcon branch. */
  renderSelectedOutcomeIcon?: (option: Option) => ReactNode;
  delayUpdate?: boolean;
  disableDropdownOpening?: boolean;
  /** Shown when no outcome is selected; defaults to "Add Outcome". */
  addOutcomeLabel?: string;
  /**
   * When true, the Transfer overlay width matches the trigger width (updates on resize while open).
   * Use for fluid-width controls (e.g. call detail drawer).
   */
  matchDropdownWidthToTrigger?: boolean;
};

export type CallOutcome = {
  key: string;
  label: string;
};

export enum CustomOutcomeDropdownPlacement {
  Top = 'top',
  Bottom = 'bottom',
  DynamicTop = 'DynamicTop',
  DynamicBottom = 'DynamicBottom',
}

export type IState = {
  selectedOption: any;
  show: boolean;
  showCreateProspectCustomOutcomeModal: boolean;
  elementBottom: number;
  placement: CustomOutcomeDropdownPlacement;
  /** Measured trigger width (px) when `matchDropdownWidthToTrigger` is on. */
  dropdownTriggerWidth: number | null;
};

export type Option = {
  key: number | string;
  id: number;
  name: ProspectOutcomeDisplayName | string;
  emoji: string | ReactNode;
  total?: number;
  textColor: string;
  bgColor: string;
  isDefault: boolean;
  sentiment: OutcomeSentiment;
};
